import { IPostbackSendFormLang, POSTBACK_SEND_FORM_LANG_KEY } from './interface.IPostbackSendFormLang'

export * from './interface.IPostbackSendFormLang'

export type IPostbackSendAllLang =
	& IPostbackSendFormLang

export const POSTBACK_SEND_ALL_LANG_KEY: IPostbackSendAllLang = {
	...POSTBACK_SEND_FORM_LANG_KEY,
}
